var _path, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPa = function SvgPa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v24H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#005293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pa_svg__c",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pa_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pa_svg__a",
    d: "M0-3v3h1.5z",
    transform: "rotate(18 0 -3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pa_svg__a",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pa_svg__b",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pa_svg__b",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pa_svg__b",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pa_svg__b",
    transform: "rotate(288)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 12h18v12H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#d21034"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0h18v12H18z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pa_svg__c",
    x: 18,
    y: 12
  }))));
};

export default SvgPa;